import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { CustomItem, DonationItem, ENVIRONMENT, Environment, Lead, sizeDescriptions, Specification } from '@domains';
import { FlowService } from '@donor/screens/flow/donor-flow.service';
import { CustomItemService } from '@rspl-api';
import {
  Designable,
  DesignService,
  FxFlexDirective,
  FxLayoutAlignDirective,
  FxLayoutDirective,
  FxLayoutGapDirective,
  ResponsiveService,
} from '@rspl-ui';
import { take } from 'rxjs';

@Component({
  selector: 'app-add-custom-item-dialog',
  templateUrl: './add-custom-item-dialog.component.html',
  styleUrls: ['./add-custom-item-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    FxLayoutDirective,
    FxLayoutGapDirective,
    MatIcon,
    FxLayoutAlignDirective,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatLabel,
    MatInput,
    FxFlexDirective,
    MatRadioGroup,
    MatRadioModule,
  ],
})
export class AddCustomItemDialogComponent extends Designable implements OnInit {
  disassembly: boolean;
  count = 1;
  sizeDescriptions = sizeDescriptions;
  lead: Lead;
  name = new FormControl<string>(null, Validators.required);
  size: 'xlarge' | 'large' | 'medium' | 'small';
  public constructor(
    public reference: MatDialogRef<AddCustomItemDialogComponent>,
    @Inject(ENVIRONMENT) protected environment: Environment,
    protected override designService: DesignService,
    public override responsiveService: ResponsiveService,
    public flowService: FlowService,
    private customItemService: CustomItemService,
  ) {
    super(designService, responsiveService);
  }

  override ngOnInit(): void {
    this.lead = new Lead(this.flowService.lead);
  }

  removeItem(): void {
    if (this.count > 1) {
      this.count = this.count - 1;
    }
  }

  addItem(): void {
    this.count = this.count + 1;
  }

  handleQuantityChangeThroughInput(event: any) {
    const value = Number(event.target.value.replace(/[^0-9]/g, ''));
    event.target.value = value;

    this.count = value;
  }

  submit(): void {
    if (this.name.valid && this.size) {
      this.customItemService
        .create(
          new CustomItem({
            name: this.name.value,
            specification: new Specification({
              xlarge: this.size === 'xlarge' ? 1 : 0,
              large: this.size === 'large' ? 1 : 0,
              medium: this.size === 'medium' ? 1 : 0,
              disassembly: this.disassembly ? 1 : 0,
            }),
          }),
        )
        .pipe(take(1))
        .subscribe((customItem) => {
          if (this.disassembly === true) {
            this.lead.specification.disassembly += this.count;
          }
          this.lead.aggregatedItems.push({
            item: new DonationItem({
              id: customItem.id,
              name: customItem.name,
              description: customItem.description,
              type: 'CustomItem',
              xlarge: customItem.specification.xlarge,
              large: customItem.specification.large,
              medium: customItem.specification.medium,
            }),
            count: this.count,
          });
          this.flowService.updateCart(this.lead).subscribe({
            next: () => {
              this.reference.close(true);
            },
            error: (err) => {
              console.error('Error updating Cart:', err);
            },
          });
        });
    }
  }
}
